export const sotrageKeys = {
    lang: "lang"
}